import {
  getAllContactList,
  getDispositionForCustomers,
  getQueueeList,
  getTagsForCustomers,
  searchQueueList,
} from "../../api/helperspi/contactListapiService";

import { ALL_CONTACT_LIST } from "../../../constants/reducer_names";
import _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";
import { hassAccess } from "../../../base/utils";

export const initialState = {
  allContactList: [],
  isGetAllcontacts: false,
  isGetAllTags: false,
  allCustomerTagList: [],
  dispositionTagList: [],
  isDisposition: false,
  isQueueList: false,
  AllQueueList: [],
  filterQueueList: []
};

const getAllContactListSlice = createSlice({
  name: ALL_CONTACT_LIST,
  initialState,
  reducers: {
    reset: () => {},
  },

  extraReducers: (builder) => {
    // builder.addCase(getAllContactList.fulfilled, (state, { payload }) => {
    //   if (payload?.data?.statusCode === 200) {
    //     state.allContactList = payload.data.getConatctListRes;
    //     state.isGetAllcontacts = true;
    //   }
    // });


    builder.addCase(getTagsForCustomers.fulfilled, (state, { payload }) => {
      if (payload?.data?.statusCode === 200) {
        state.allCustomerTagList = payload.data.getCustomerTagListRes;
        state.isGetAllTags = true;
      }
    });


    builder.addCase(getQueueeList.fulfilled, (state, { payload }) => {
      if (payload?.data?.statusCode === 200) {
        let queueList: any = payload.data.getQueueLists;
        // outBoundCallStatus

        let filterList: any = _.filter(queueList, (queue: any) => queue.outBoundCallStatus === 1)
        state.AllQueueList = payload.data.getQueueLists
        state.filterQueueList = filterList
        state.isQueueList = true
      }
    });


    builder.addCase(searchQueueList.fulfilled, (state, { payload }) => {
      if (payload?.data?.statusCode === 200) {
        state.AllQueueList = payload.data.getQueueLists;
        state.filterQueueList = payload.data.getQueueeLists;
      }
    });

    builder.addCase(
      getDispositionForCustomers.fulfilled,
      (state, { payload }) => {
        if (payload?.data?.statusCode === 200) {
          const list = payload?.data?.getDispositinListRes || [];

          state.dispositionTagList = hassAccess('settings/voice/CallFlowList')
            ? list
            : list.filter((item: any) => item?.type === 'Default');
          state.isDisposition = true;
        }
      }
    );
  },
});
export const getAllContactListActions = getAllContactListSlice.actions;
export default getAllContactListSlice.reducer;
